module.exports = __webpack_public_path__ + "07e39ceef223f1296b6cc023752b2bca.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-28@2x.png
// module id = 510
// module chunks = 0